import { FC, useEffect, useState, useCallback } from 'react';
import { Collapse } from 'antd';
import css from './index.module.scss';
// import useCopy from './useCopy';
import EFArrowRight from '@/components/UI/svg/Icons/EFArrowRight';
import { useReferralStore } from '@/components/Ambassador/ReferralProvider';
import { getReferralFaq } from '@/service/referral';
import getLocal from '@/app/utils/getLocal';

// interface MinCardProps {
//     title: string;
//     list: { key?: string; ask: string; quest: string }[];
// }

interface FaqDataType {
    faqModuleTitle: string;
    faqList: { faqContent: string; faqTitle: string }[];
}

const { Panel } = Collapse;
const Faq: FC = () => {
    const { locale } = getLocal();
    const { referralInfo } = useReferralStore();
    // const [collapseList, setCollapseList] = useState<any>([]);
    const [faqData, setFaqData] = useState<FaqDataType | null>(null);
    // const { t } = useLang('referral');

    // const originData: MinCardProps[] = [
    //     {
    //         title: t('faq.referral_program'),
    //         list: [
    //             { key: 'referral_program_q1', quest: t('faq.referral_program_q1'), ask: t('faq.referral_program_a1') },
    //             { key: 'referral_program_q2', quest: t('faq.referral_program_q2'), ask: t('faq.referral_program_a2') },
    //             { key: 'referral_program_q3', quest: t('faq.referral_program_q3'), ask: t('faq.referral_program_a3') },
    //             { key: 'referral_program_q4', quest: t('faq.referral_program_q4'), ask: t('faq.referral_program_a4') },
    //             { key: 'referral_program_q5', quest: t('faq.referral_program_q5'), ask: t('faq.referral_program_a5') },
    //             { key: 'referral_program_q6', quest: t('faq.referral_program_q6'), ask: t('faq.referral_program_a6') },
    //             { key: 'referral_program_q7', quest: t('faq.referral_program_q7'), ask: t('faq.referral_program_a7') },
    //             {
    //                 key: 'referral_program_q8',
    //                 quest: t('faq.referral_program_q8'),
    //                 ask: t.rich('faq.referral_program_a8', {
    //                     email: (text: string) => <a href={`mailto:${text}`}>{text}</a>,
    //                 }),
    //             },
    //         ],
    //     },
    //     {
    //         title: t('faq.referrers'),
    //         list: [
    //             { key: 'referrers_q1', quest: t('faq.referrers_q1'), ask: t('faq.referrers_a1') },
    //             {
    //                 key: 'referrers_q2',
    //                 quest: t('faq.referrers_q2'),
    //                 ask: t.rich('faq.referrers_a2', {
    //                     a: (text: string) => <a href={text}>{text}</a>,
    //                 }),
    //             },
    //             { key: 'referrers_q3', quest: t('faq.referrers_q3'), ask: t('faq.referrers_a3') },
    //             // { quest: t('faq.referrers_q4'), ask: t('faq.referrers_a4') },
    //             { key: 'referrers_q5', quest: t('faq.referrers_q5'), ask: t('faq.referrers_a5') },
    //             { key: 'referrers_q6', quest: t('faq.referrers_q6'), ask: t('faq.referrers_a6') },
    //             { key: 'referrers_q15', quest: t('faq.referrers_q15'), ask: t('faq.referrers_a15') },
    //             { key: 'referrers_q16', quest: t('faq.referrers_q16'), ask: t('faq.referrers_a16') },
    //             { key: 'referrers_q17', quest: t('faq.referrers_q17'), ask: t('faq.referrers_a17') },
    //             { key: 'referrers_q18', quest: t('faq.referrers_q18'), ask: t('faq.referrers_a18') },
    //             { key: 'referrers_q19', quest: t('faq.referrers_q19'), ask: t('faq.referrers_a19') },
    //             { key: 'referrers_q20', quest: t('faq.referrers_q20'), ask: t('faq.referrers_a20') },
    //             {
    //                 key: 'referrers_q7',
    //                 quest: t('faq.referrers_q7'),
    //                 ask: t.rich('faq.referrers_a7', {
    //                     a: (text: string) => <a href="ecocredits">{text}</a>,
    //                 }),
    //             },
    //             // { quest: t('faq.referrers_q8'), ask: t('faq.referrers_a8') },
    //             { key: 'referrers_q9', quest: t('faq.referrers_q9'), ask: t('faq.referrers_a9') },
    //             { key: 'referrers_q10', quest: t('faq.referrers_q10'), ask: t('faq.referrers_a10') },
    //             { key: 'referrers_q11', quest: t('faq.referrers_q11'), ask: t('faq.referrers_a11') },
    //             {
    //                 key: 'referrers_q12',
    //                 quest: t('faq.referrers_q12'),
    //                 ask: t.rich('faq.referrers_a12', {
    //                     email: (text: string) => <a href={`mailto:${text}`}>{text}</a>,
    //                 }),
    //             },
    //             { key: 'referrers_q13', quest: t('faq.referrers_q13'), ask: t('faq.referrers_a13') },
    //             { key: 'referrers_q14', quest: t('faq.referrers_q14'), ask: t('faq.referrers_a14') },
    //         ],
    //     },
    //     {
    //         title: t('faq.referees'),
    //         list: [
    //             { key: 'referees_q1', quest: t('faq.referees_q1'), ask: t('faq.referees_a1') },
    //             { key: 'referees_q2', quest: t('faq.referees_q2'), ask: t('faq.referees_a2') },
    //             { key: 'referees_q3', quest: t('faq.referees_q3'), ask: t('faq.referees_a3') },
    //             { key: 'referees_q4', quest: t('faq.referees_q4'), ask: t('faq.referees_a4') },
    //         ],
    //     },
    // ];

    // const { data } = useCopy(originData, referralInfo?.planType);

    const getFaqList = useCallback(
        async (planId: string) => {
            const res = await getReferralFaq(locale, planId);

            if (res.code === '0') {
                if (res.data) {
                    setFaqData(res.data);
                } else {
                    setFaqData(null);
                }
            }
        },
        [locale],
    );

    useEffect(() => {
        if (referralInfo?.planId) {
            getFaqList(referralInfo.planId);
        }
    }, [referralInfo, getFaqList]);

    return (
        <div className={`${css.faq} ${faqData ? '' : 'none'}`} id="ECO_FAQ">
            <h5 className="faq_title">
                <span className="title-text">{faqData?.faqModuleTitle}</span>
            </h5>
            <Collapse accordion className="faq-collapse" ghost expandIcon={() => <EFArrowRight />}>
                {faqData?.faqList?.map((item, index) => (
                    <Panel header={item.faqTitle} key={index}>
                        <div dangerouslySetInnerHTML={{ __html: item.faqContent }}></div>
                    </Panel>
                ))}
            </Collapse>
        </div>
    );
};

export default Faq;
